import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import "vant/lib/picker/style";
import _Picker from "vant/lib/picker";
import * as tslib_1 from "tslib";
import { Component, Vue, Emit } from "vue-property-decorator";
import { i18n } from "@/i18n/i18n-setup";
Vue.use(_Picker);

var SelectBirthday =
/*#__PURE__*/
function (_Vue) {
  _inherits(SelectBirthday, _Vue);

  function SelectBirthday() {
    var _this;

    _classCallCheck(this, SelectBirthday);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectBirthday).apply(this, arguments));
    _this.sexColumns = [i18n.t("infomation.gender_list[0]"), i18n.t("infomation.gender_list[1]"), i18n.t("infomation.gender_list[2]")];
    _this.done = i18n.t("common.button.done");
    _this.cancel = i18n.t("common.button.cancel");
    return _this;
  }

  _createClass(SelectBirthday, [{
    key: "onConfirm",
    value: function onConfirm(value) {
      this.$emit("showGenderMask", false);
    }
  }, {
    key: "closeMask",
    value: function closeMask() {
      this.$emit("showGenderMask", false);
    }
  }, {
    key: "onChange",
    value: function onChange(picker, values) {}
  }]);

  return SelectBirthday;
}(Vue);

tslib_1.__decorate([Emit("input")], SelectBirthday.prototype, "onConfirm", null);

SelectBirthday = tslib_1.__decorate([Component({
  components: {}
})], SelectBirthday);
export default SelectBirthday;